// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-head_block {\n  display: flex;\n  justify-content: space-between;\n}\n\nion-thumbnail {\n  --size: 100px ;\n}\n\n.service-title {\n  max-width: 70%;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
